import {
	createContext,
	type Dispatch,
	type ReactNode,
	type SetStateAction,
	useEffect,
	useState
} from 'react';

type UserDataContextType = {
	userName: string;
	userEmail: string;
	admin: boolean;
	token: string;
};

type UserDataContextProps = {
	userData: UserDataContextType;
	setUserData: Dispatch<SetStateAction<UserDataContextType>>;
};

type UserDataProviderProps = {
	children: ReactNode;
};

function getInfoUser() {
	const infoUserData = localStorage.getItem('user');

	if (infoUserData) {
		const parsedInfo = JSON.parse(infoUserData);
		const { token, infoUser } = parsedInfo;

		return { infoUser, token };
	}
}

const dataUser = getInfoUser();

const DEFAULT_VALUE: UserDataContextProps = {
	userData: {
		userName: dataUser?.infoUser.name || '',
		userEmail: dataUser?.infoUser.email || '',
		admin: dataUser?.infoUser.adm || false,
		token: dataUser?.token || ''
	},
	setUserData: () => {}
};

export const UserDataContext = createContext<UserDataContextProps>(DEFAULT_VALUE);

export function UserDataProvider({ children }: UserDataProviderProps) {
	const [userData, setUserData] = useState(DEFAULT_VALUE.userData);

	useEffect(() => {
		getInfoUser();
	}, []);

	return (
		<UserDataContext.Provider
			value={{
				userData,
				setUserData
			}}
		>
			{children}
		</UserDataContext.Provider>
	);
}
